// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.solutions_startup__8ZcRd {
  display: grid;
  gap: var(--space-6);
  grid-template-columns: minmax(0, 1fr);
  align-items: start;
  margin-bottom: clamp(3rem, 2rem + 4vw, 6rem);
}
.solutions_figureBlock__0I-fr {
  position: relative;
  padding: clamp(2rem, 1.5rem + 3vw, 3.5rem);
  background: var(--kur-gold);
  border-radius: 0 var(--radius-lg) 0 var(--radius-lg);
  color: #111;
}
.solutions_figure__IURUc {
  margin: 0;
  font-size: clamp(5rem, 3rem + 9vw, 10rem);
  line-height: 0.9;
  font-weight: 500;
  letter-spacing: var(--tracking-figure);
}
.solutions_figure__IURUc span {
  margin-left: 0.5rem;
  font-size: 0.25em;
  letter-spacing: 0;
}
.solutions_figureCaption__9Qe75 {
  margin: var(--space-4) 0 0;
  max-width: 18rem;
  font-weight: 500;
}
.solutions_h3__lUfee {
  margin: 0 0 var(--space-3);
  font-size: var(--text-h3);
  font-weight: 500;
}
.solutions_text__mxGMK {
  margin: 0 0 var(--space-5);
  max-width: 38rem;
  line-height: var(--leading-body);
  color: var(--color-text-muted);
}
.solutions_steps__0HAbw {
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: step;
  border-top: 1px solid var(--color-border);
}
.solutions_steps__0HAbw li {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  padding: 0.85rem 0;
  border-bottom: 1px solid var(--color-border);
  font-weight: 500;
}
.solutions_steps__0HAbw span {
  width: 1.9rem;
  height: 1.9rem;
  flex: none;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: var(--color-ink);
  color: #fff;
  font-size: var(--text-caption);
  font-weight: 700;
}

.solutions_central__SPrPL {
  padding-top: var(--space-7);
  border-top: 1px solid var(--color-border);
}
.solutions_centralHead__whq3v {
  max-width: 40rem;
}
.solutions_groups__Oh1fL {
  display: grid;
  gap: var(--space-5);
  grid-template-columns: minmax(0, 1fr);
}
.solutions_group__Vm812 {
  padding: var(--space-6);
  background: var(--color-cloud);
  border-radius: var(--radius-lg);
}
.solutions_groupTitle__NH6bl {
  margin: 0 0 var(--space-4);
  font-size: var(--text-eyebrow);
  letter-spacing: var(--tracking-eyebrow);
  text-transform: uppercase;
  font-weight: 700;
  color: var(--color-slate);
}
.solutions_items__p7zoa {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 0.6rem;
}
.solutions_items__p7zoa li {
  position: relative;
  padding-left: 1.25rem;
  line-height: 1.4;
}
.solutions_items__p7zoa li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.55em;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  border: 2px solid var(--kur-amber);
}

@media (min-width: 640px) and (max-width: 1199px) {
  .solutions_items__p7zoa {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: var(--space-5);
  }
}
/* three groups side by side only where each column fits its longest item */
@media (min-width: 1200px) {
  .solutions_groups__Oh1fL {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 992px) {
  .solutions_startup__8ZcRd {
    grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);
    gap: var(--space-8);
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/SPONSORS/SECTIONS/SOLUTIONS/solutions.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,2BAA2B;EAC3B,oDAAoD;EACpD,WAAW;AACb;AACA;EACE,SAAS;EACT,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,cAAc;EACd,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,uCAAuC;EACvC,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,gDAAgD;IAChD,0BAA0B;EAC5B;AACF;AACA,2EAA2E;AAC3E;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,wDAAwD;IACxD,mBAAmB;EACrB;AACF","sourcesContent":[".startup {\n  display: grid;\n  gap: var(--space-6);\n  grid-template-columns: minmax(0, 1fr);\n  align-items: start;\n  margin-bottom: clamp(3rem, 2rem + 4vw, 6rem);\n}\n.figureBlock {\n  position: relative;\n  padding: clamp(2rem, 1.5rem + 3vw, 3.5rem);\n  background: var(--kur-gold);\n  border-radius: 0 var(--radius-lg) 0 var(--radius-lg);\n  color: #111;\n}\n.figure {\n  margin: 0;\n  font-size: clamp(5rem, 3rem + 9vw, 10rem);\n  line-height: 0.9;\n  font-weight: 500;\n  letter-spacing: var(--tracking-figure);\n}\n.figure span {\n  margin-left: 0.5rem;\n  font-size: 0.25em;\n  letter-spacing: 0;\n}\n.figureCaption {\n  margin: var(--space-4) 0 0;\n  max-width: 18rem;\n  font-weight: 500;\n}\n.h3 {\n  margin: 0 0 var(--space-3);\n  font-size: var(--text-h3);\n  font-weight: 500;\n}\n.text {\n  margin: 0 0 var(--space-5);\n  max-width: 38rem;\n  line-height: var(--leading-body);\n  color: var(--color-text-muted);\n}\n.steps {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  counter-reset: step;\n  border-top: 1px solid var(--color-border);\n}\n.steps li {\n  display: flex;\n  align-items: center;\n  gap: var(--space-4);\n  padding: 0.85rem 0;\n  border-bottom: 1px solid var(--color-border);\n  font-weight: 500;\n}\n.steps span {\n  width: 1.9rem;\n  height: 1.9rem;\n  flex: none;\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  background: var(--color-ink);\n  color: #fff;\n  font-size: var(--text-caption);\n  font-weight: 700;\n}\n\n.central {\n  padding-top: var(--space-7);\n  border-top: 1px solid var(--color-border);\n}\n.centralHead {\n  max-width: 40rem;\n}\n.groups {\n  display: grid;\n  gap: var(--space-5);\n  grid-template-columns: minmax(0, 1fr);\n}\n.group {\n  padding: var(--space-6);\n  background: var(--color-cloud);\n  border-radius: var(--radius-lg);\n}\n.groupTitle {\n  margin: 0 0 var(--space-4);\n  font-size: var(--text-eyebrow);\n  letter-spacing: var(--tracking-eyebrow);\n  text-transform: uppercase;\n  font-weight: 700;\n  color: var(--color-slate);\n}\n.items {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  gap: 0.6rem;\n}\n.items li {\n  position: relative;\n  padding-left: 1.25rem;\n  line-height: 1.4;\n}\n.items li::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0.55em;\n  width: 0.5rem;\n  height: 0.5rem;\n  border-radius: 50%;\n  border: 2px solid var(--kur-amber);\n}\n\n@media (min-width: 640px) and (max-width: 1199px) {\n  .items {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    column-gap: var(--space-5);\n  }\n}\n/* three groups side by side only where each column fits its longest item */\n@media (min-width: 1200px) {\n  .groups {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 992px) {\n  .startup {\n    grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);\n    gap: var(--space-8);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"startup": `solutions_startup__8ZcRd`,
	"figureBlock": `solutions_figureBlock__0I-fr`,
	"figure": `solutions_figure__IURUc`,
	"figureCaption": `solutions_figureCaption__9Qe75`,
	"h3": `solutions_h3__lUfee`,
	"text": `solutions_text__mxGMK`,
	"steps": `solutions_steps__0HAbw`,
	"central": `solutions_central__SPrPL`,
	"centralHead": `solutions_centralHead__whq3v`,
	"groups": `solutions_groups__Oh1fL`,
	"group": `solutions_group__Vm812`,
	"groupTitle": `solutions_groupTitle__NH6bl`,
	"items": `solutions_items__p7zoa`
};
export default ___CSS_LOADER_EXPORT___;
